import { createLabeledMessages } from '@gef-ui/localization/messageUtils';

const sidebar = {
	campaign: 'kampaně',
	policyHolder: 'pojistník',
	information: 'informace',
	production: 'produkce',
	tasks: 'úkoly',
	searchResults: 'výsledky vyhledávání',
	newPolicy: 'Nová smlouva',
	numbersPS: 'Přidělení čísla PS',
	searchPS: 'Vyhledání čísla PS',
	modelation: 'Modelace',
	newSubPolicy: 'Nová podsmlouva',
	searchInGroup: 'Vyhledat ve skupině',
	fleetManagement: 'Správa flotil',
	verificationOfCover: 'Ověření krytí',
	competitiveComparison: 'Konkurenční srovnání',
	reportOverview: 'Přehled reportů',
	verifyPolicyHolder: 'Ověření získatele',
	cesto: 'CESTO',
};

const navigation = {
	trader: 'obchodník',
	manager: 'manažer',
	hq: 'centrála',
	client: 'klient',
	home: 'domov',
	administrationLink: 'administrace',
	logout: 'Odhlásit',
	loginAs: 'Přihlásit se jako',
	loggedInRole: 'Přihlášen v roli',
	loggedAsRole: 'Přihlásit se v roli',
};

const common = {
	contactHistory: 'kontaktní historie',
	campaigns: 'kampaně',
	notes: 'poznámky',
};

const policies = {
	policies: 'smlouvy',
	partnerClaims: 'pojistné události',
};

const manual = {
	news: 'Novinky a články',
	instruction: 'Videa a příručky (IDK)',
	instructionEDK: 'Videa a příručky (EDK)',
	crm: 'CRM Stránky',
	businessCampaigns: 'Obchodní kampaně',
	clientWays: 'Klientské cesty',
	leadManagement: 'Lead Management',
	retention: 'Retence',
};

const merge = {
	...sidebar,
	...navigation,
	...policies,
	...common,
	...manual,
};

export default Object.assign({}, merge, createLabeledMessages({ ...merge }));
